<div class="announcements-admin" data-tour="announcements-overview">
  <div class="header" data-tour-ready="announcements-overview">
    <h1>{{ 'ADMIN.ANNOUNCEMENTS.TITLE' | translate }}</h1>
  </div>

  <!-- Templates declared first -->
  <ng-template #annInfoMessage>
    <strong>{{ 'ADMIN.ANNOUNCEMENTS.INFO.TITLE' | translate }}</strong>
  </ng-template>

  <ng-template #annInfoDescription>
    <ul class="info-points">
      <li>{{ 'ADMIN.ANNOUNCEMENTS.INFO.DESCRIPTION_1' | translate }}</li>
      <li>{{ 'ADMIN.ANNOUNCEMENTS.INFO.DESCRIPTION_2' | translate }}</li>
      <li>{{ 'ADMIN.ANNOUNCEMENTS.INFO.DESCRIPTION_3' | translate }}</li>
      <li>{{ 'ADMIN.ANNOUNCEMENTS.INFO.DESCRIPTION_4' | translate }}</li>
    </ul>
  </ng-template>

  <ng-template #propertyNotFoundTpl>
    <div style="padding: 8px 4px;">
      <div style="margin-bottom: 8px;">
        {{ 'ADMIN.ANNOUNCEMENTS.NO_PROPERTIES_HINT' | translate }}
      </div>

      <button nz-button nzType="link" (click)="goToProperties()">
        {{ 'ADMIN.ANNOUNCEMENTS.GO_TO_PROPERTIES' | translate }}
      </button>
    </div>
  </ng-template>

  <nz-card class="notfall-guide-card" [nzBordered]="false">
    <div class="guide-row">
      <div class="guide-main">
        <div class="guide-icon-wrap" aria-hidden="true">
          <span nz-icon nzType="file-pdf" nzTheme="outline"></span>
        </div>

        <div class="guide-text">
          <div class="guide-kicker">
            <span nz-icon nzType="safety-certificate"></span>
            {{ 'ADMIN.ANNOUNCEMENTS.NOTFALL_GUIDE.BADGE' | translate }}
          </div>

          <div class="guide-title">
            {{ 'ADMIN.ANNOUNCEMENTS.NOTFALL_GUIDE.TITLE' | translate }}
          </div>

          <div class="guide-sub">
            {{ 'ADMIN.ANNOUNCEMENTS.NOTFALL_GUIDE.SUB' | translate }}
          </div>
        </div>
      </div>

      <div class="guide-actions">
        <a
          nz-button
          nzType="default"
          class="guide-btn guide-btn-preview"
          [href]="notfallGuideUrl"
          target="_blank"
          rel="noopener"
        >
          <span nz-icon nzType="eye"></span>
          {{ 'ADMIN.ANNOUNCEMENTS.NOTFALL_GUIDE.PREVIEW' | translate }}
        </a>

        <a
          nz-button
          nzType="primary"
          class="guide-btn guide-btn-download"
          [href]="notfallGuideUrl"
          download="Kurzanleitung-Notfall-Aushang.pdf"
        >
          <span nz-icon nzType="download"></span>
          {{ 'ADMIN.ANNOUNCEMENTS.NOTFALL_GUIDE.DOWNLOAD' | translate }}
        </a>
      </div>
    </div>
  </nz-card>

  <!-- Bind templates to nzMessage / nzDescription -->
  <nz-alert
    nzType="info"
    nzShowIcon
    class="announcements-info"
    [nzMessage]="annInfoMessage"
    [nzDescription]="annInfoDescription">
  </nz-alert>

  <!-- Clear property selection toolbar -->
  <nz-card class="property-toolbar" [nzBordered]="false">
    <div class="toolbar-head">
      <span nz-icon nzType="home" class="toolbar-icon"></span>
      <div class="toolbar-titles">
        <div class="toolbar-title">
          {{ 'ADMIN.ANNOUNCEMENTS.PROPERTY_TOOLBAR.TITLE' | translate }}
        </div>
        <div class="toolbar-sub">
          {{ 'ADMIN.ANNOUNCEMENTS.PROPERTY_TOOLBAR.SUB' | translate }}
        </div>
      </div>
    </div>

    <div class="toolbar-controls">
      <div class="toolbar-actions">
        <button
          nz-button
          nzType="link"
          nzSize="small"
          (click)="selectAllInFilter()"
          [disabled]="selectAllCurrent || selectAllLoading || !currentFilterIds.length || isEditing"
          [nzLoading]="selectAllLoading"
        >
          {{ 'ADMIN.ANNOUNCEMENTS.PROPERTY_TOOLBAR.SELECT_ALL_FILTER' | translate }}
        </button>
        <button
          nz-button
          nzType="link"
          nzSize="small"
          (click)="clearPropertySelection()"
          [disabled]="!selectedPropertyIds.length || isEditing"
        >
          {{ 'ADMIN.ANNOUNCEMENTS.PROPERTY_TOOLBAR.CLEAR_SELECTION' | translate }}
        </button>
      </div>

      <label class="toolbar-label">
        {{ 'ADMIN.ANNOUNCEMENTS.PROPERTY' | translate }}
      </label>

      <nz-form-item>
        <nz-form-control
          [nzValidateStatus]="controlValidationStatus('propertyIds')"
          [nzErrorTip]="propertyErrorTpl"
        >
          <nz-tree-select
            class="toolbar-tree"
            [nzNodes]="propertyNodes"
            nzCheckable
            nzMultiple
            [nzShowSearch]="true"
            [nzHideUnMatched]="true"
            [nzVirtualHeight]="propertyVirtualHeight"
            [nzDropdownMatchSelectWidth]="false"
            [nzDisabled]="isEditing"
            [nzStatus]="controlValidationStatus('propertyIds')"
            [nzPlaceHolder]="'ADMIN.ANNOUNCEMENTS.SELECT_PROPERTY' | translate"
            [(ngModel)]="selectedPropertyIds"
            (ngModelChange)="onPropertySelectionChange($event)"
            [nzMaxTagCount]="3"
            [nzMaxTagPlaceholder]="tagPlaceholder"
            [nzNotFoundContent]="propertyNotFoundTpl"
          ></nz-tree-select>
        </nz-form-control>
      </nz-form-item>

      <ng-template #propertyErrorTpl>
        {{ 'ADMIN.ANNOUNCEMENTS.REQUIRE_PROPERTY' | translate }}
      </ng-template>

      <ng-template #tagPlaceholder let-selectedList>
        <span>
          {{ 'ADMIN.ANNOUNCEMENTS.PROPERTY_TOOLBAR.MORE' | translate:{ count: selectedList.length } }}
        </span>
      </ng-template>
    </div>

    <div class="toolbar-summary">
      <span class="toolbar-count">
        {{ 'ADMIN.ANNOUNCEMENTS.PROPERTY_TOOLBAR.SELECTED_COUNT' | translate:{ count: selectedPropertyCount } }}
      </span>
      <span *ngIf="isEditing" class="toolbar-edit-lock">
        {{ 'ADMIN.ANNOUNCEMENTS.PROPERTY_TOOLBAR.EDIT_LOCK' | translate }}
      </span>
    </div>
  </nz-card>

  <form [formGroup]="form" nz-form class="announcement-form">
    <div class="form-grid">
      <nz-row [nzGutter]="16">
        <nz-col [nzXs]="24" [nzMd]="16">
          <nz-form-item>
            <nz-form-label [nzFor]="'title'">
              {{ 'ADMIN.ANNOUNCEMENTS.FIELDS.TITLE' | translate }}
            </nz-form-label>

            <nz-form-control [nzValidateStatus]="controlValidationStatus('title')" [nzErrorTip]="titleErrorTpl">
              <input nz-input formControlName="title" id="title" />
            </nz-form-control>
          </nz-form-item>

          <!-- Error template for title -->
          <ng-template #titleErrorTpl>
            <ng-container *ngIf="form.controls['title'].hasError('required')">
              {{ 'ADMIN.ANNOUNCEMENTS.ERROR_TITLE_REQUIRED' | translate }}
            </ng-container>

            <ng-container *ngIf="form.controls['title'].hasError('maxlength')">
              {{ 'ADMIN.ANNOUNCEMENTS.ERROR_TITLE_MAXLENGTH' | translate:{ max: 120 } }}
            </ng-container>
          </ng-template>
        </nz-col>

        <nz-col [nzXs]="24" [nzMd]="8">
          <nz-form-item>
            <nz-form-label>{{ 'ADMIN.ANNOUNCEMENTS.FIELDS.URGENCY' | translate }}</nz-form-label>
            <nz-form-control [nzValidateStatus]="controlValidationStatus('urgency')" [nzErrorTip]="urgencyErrorTpl">
              <nz-select formControlName="urgency" [nzStatus]="controlValidationStatus('urgency')">
                <nz-option nzValue="normal" [nzLabel]="'ADMIN.ANNOUNCEMENTS.URGENCY.NORMAL' | translate"></nz-option>
                <nz-option nzValue="urgent" [nzLabel]="'ADMIN.ANNOUNCEMENTS.URGENCY.URGENT' | translate"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <ng-template #urgencyErrorTpl>
            {{ 'ADMIN.ANNOUNCEMENTS.ERROR_URGENCY_REQUIRED' | translate }}
          </ng-template>
        </nz-col>
      </nz-row>

      <nz-row [nzGutter]="16">
        <nz-col [nzSpan]="24">
          <nz-form-item class="body-item">
            <nz-form-label [nzFor]="'summary'">
              {{ 'ADMIN.ANNOUNCEMENTS.FIELDS.SUMMARY' | translate }}
            </nz-form-label>

            <nz-form-control [nzValidateStatus]="controlValidationStatus('summary')" [nzErrorTip]="summaryErrorTpl">
              <textarea nz-input rows="3" formControlName="summary" id="summary"></textarea>
            </nz-form-control>
          </nz-form-item>

          <ng-template #summaryErrorTpl>
            <ng-container *ngIf="form.controls['summary'].hasError('required')">
              {{ 'ADMIN.ANNOUNCEMENTS.ERROR_SUMMARY_REQUIRED' | translate }}
            </ng-container>

            <ng-container *ngIf="form.controls['summary'].hasError('maxlength')">
              {{ 'ADMIN.ANNOUNCEMENTS.ERROR_SUMMARY_MAXLENGTH' | translate:{ max: 500 } }}
            </ng-container>
          </ng-template>
        </nz-col>
      </nz-row>

      <nz-row [nzGutter]="16">
        <nz-col [nzXs]="24" [nzMd]="8">
          <nz-form-item>
            <nz-form-label>{{ 'ADMIN.ANNOUNCEMENTS.FIELDS.VALID_FROM' | translate }}</nz-form-label>
            <nz-form-control [nzValidateStatus]="controlValidationStatus('validFrom')" [nzErrorTip]="validFromErrorTpl">
              <nz-date-picker
                formControlName="validFrom"
                [nzStatus]="controlValidationStatus('validFrom')"
                [nzShowTime]="{ nzFormat: 'HH:mm' }"
                nzFormat="yyyy-MM-dd HH:mm"
                [nzDisabledDate]="disabledPastDates"
                [nzDisabledTime]="disabledPastTime">
              </nz-date-picker>
            </nz-form-control>
          </nz-form-item>

          <ng-template #validFromErrorTpl>
            {{ 'ADMIN.ANNOUNCEMENTS.ERROR_VALID_FROM_REQUIRED' | translate }}
          </ng-template>
        </nz-col>

        <nz-col [nzXs]="24" [nzMd]="8">
          <nz-form-item>
            <nz-form-label>{{ 'ADMIN.ANNOUNCEMENTS.FIELDS.VALID_TO' | translate }}</nz-form-label>
            <nz-form-control>
              <nz-date-picker
                formControlName="validTo"
                [nzShowTime]="{ nzFormat: 'HH:mm' }"
                nzFormat="yyyy-MM-dd HH:mm"
                [nzDisabledDate]="disabledValidToDates"
                [nzDisabledTime]="disabledValidToTime"
              >
              </nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </nz-col>

        <nz-col [nzXs]="24" [nzMd]="8">
          <nz-form-item>
            <nz-form-label>{{ 'ADMIN.ANNOUNCEMENTS.FIELDS.SCHEDULE_AT' | translate }}</nz-form-label>
            <nz-form-control [nzValidateStatus]="controlValidationStatus('scheduleAt')" [nzErrorTip]="scheduleAtErrorTpl">
              <nz-date-picker
                formControlName="scheduleAt"
                [nzStatus]="controlValidationStatus('scheduleAt')"
                [nzShowTime]="{ nzFormat: 'HH:mm' }"
                nzFormat="yyyy-MM-dd HH:mm"
                [nzDisabledDate]="disabledScheduleDates"
                [nzDisabledTime]="disabledScheduleTime"
              >
              </nz-date-picker>
            </nz-form-control>
          </nz-form-item>

          <ng-template #scheduleAtErrorTpl>
            {{ 'ADMIN.ANNOUNCEMENTS.REQUIRE_SCHEDULE' | translate }}
          </ng-template>
        </nz-col>
      </nz-row>
    </div>

    <div class="announcement-attachments">
      <div class="attachments-header">
        <div>
          <h2>{{ 'ADMIN.ANNOUNCEMENTS.ATTACHMENTS.TITLE' | translate }}</h2>
          <p>{{ 'ADMIN.ANNOUNCEMENTS.ATTACHMENTS.DESCRIPTION' | translate }}</p>
        </div>
      </div>

      <nz-upload
        class="announcement-upload"
        [class.announcement-upload-loading]="hasAttachmentUploadsInProgress"
        nzType="drag"
        [nzCustomRequest]="uploadAttachmentRequest"
        [nzShowUploadList]="false"
        nzMultiple
        nzListType="text"
      >
        <p class="ant-upload-drag-icon"><span nz-icon nzType="inbox"></span></p>
        <p class="ant-upload-text">{{ 'ADMIN.ANNOUNCEMENTS.ATTACHMENTS.UPLOAD_HINT' | translate }}</p>
        <p class="ant-upload-hint">{{ 'ADMIN.ANNOUNCEMENTS.ATTACHMENTS.SUPPORTED_TYPES_HINT' | translate }}</p>

        <div *ngIf="hasAttachmentUploadsInProgress" class="announcement-upload-progress">
          <nz-spin nzSimple></nz-spin>
          <div class="announcement-upload-progress__text">
            {{ 'ADMIN.ANNOUNCEMENTS.ATTACHMENTS.UPLOADING' | translate:{ count: attachmentUploadingCount } }}
          </div>
          <div
            *ngFor="let uploadingFileName of attachmentUploadingFileNames"
            class="announcement-upload-progress__file"
          >
            {{ uploadingFileName }}
          </div>
        </div>
      </nz-upload>

      <div *ngIf="attachments.length; else noAttachments" class="attachment-list">
        <div
          *ngFor="let file of attachments; trackBy: trackByAttachment"
          class="attachment-row"
        >
          <div class="attachment-main">
            <span nz-icon nzType="paper-clip"></span>
            <div class="attachment-text">
              <a [href]="file.url" target="_blank" rel="noopener">{{ file.fileName }}</a>
              <span>{{ file.fileType | uppercase }}</span>
            </div>
          </div>

          <button
            nz-button
            nzType="default"
            nzDanger
            nzSize="small"
            type="button"
            [disabled]="hasAttachmentUploadsInProgress"
            (click)="removeAttachment(file)"
          >
            {{ 'ADMIN.ANNOUNCEMENTS.ATTACHMENTS.REMOVE' | translate }}
          </button>
        </div>
      </div>

      <ng-template #noAttachments>
        <div class="attachments-empty">
          {{ 'ADMIN.ANNOUNCEMENTS.ATTACHMENTS.EMPTY' | translate }}
        </div>
      </ng-template>
    </div>

    <div class="form-actions sticky-actions">
      <button nz-button nzType="default" type="button" (click)="clearSelection()">
        {{ (isEditing ? 'ADMIN.ANNOUNCEMENTS.ACTIONS.NEW' : 'ADMIN.ANNOUNCEMENTS.ACTIONS.CLEAR') | translate }}
      </button>
      <button
        *ngIf="canWriteAnnouncements"
        nz-button
        nzType="default"
        type="button"
        [nzLoading]="saving"
        [disabled]="scheduling || deleting"
        (click)="saveDraft()">
        {{ 'ADMIN.ANNOUNCEMENTS.ACTIONS.SAVE' | translate }}
      </button>
      <button
        *ngIf="canSendAnnouncements"
        nz-button
        nzType="primary"
        type="button"
        [nzLoading]="scheduling"
        [disabled]="saving || deleting"
        (click)="sendNow()">
        {{ 'ADMIN.ANNOUNCEMENTS.ACTIONS.SEND' | translate }}
      </button>
      <button
        *ngIf="canSendAnnouncements"
        nz-button
        nzType="dashed"
        type="button"
        [nzLoading]="scheduling"
        [disabled]="saving || deleting"
        (click)="scheduleSend()">
        {{ 'ADMIN.ANNOUNCEMENTS.ACTIONS.SCHEDULE' | translate }}
      </button>
    </div>
  </form>

  <!-- Table toolbar: search + filters -->
  <nz-card
    class="ann-table-toolbar"
    [nzBordered]="true"
    nzSize="small"
    [nzBodyStyle]="{ overflow: 'hidden', padding: '12px 16px', borderRadius: '12px' }"
  >
    <div class="toolbar-grid">
      <!-- Search -->
      <input
        nz-input
        class="toolbar-search"
        [placeholder]="'ADMIN.ANNOUNCEMENTS.TABLE.SEARCH' | translate"
        [(ngModel)]="tableSearch"
        (ngModelChange)="applyTableFilters()"
      />

      <!-- Urgency filter -->
      <nz-select
        class="toolbar-select"
        [(ngModel)]="urgencyFilter"
        (ngModelChange)="applyTableFilters()"
      >
        <nz-option nzValue="all"    [nzLabel]="'ADMIN.ANNOUNCEMENTS.URGENCY.ALL' | translate"></nz-option>
        <nz-option nzValue="normal" [nzLabel]="'ADMIN.ANNOUNCEMENTS.URGENCY.NORMAL' | translate"></nz-option>
        <nz-option nzValue="urgent" [nzLabel]="'ADMIN.ANNOUNCEMENTS.URGENCY.URGENT' | translate"></nz-option>
      </nz-select>

      <!-- Status filter -->
      <nz-select
        class="toolbar-select"
        [(ngModel)]="statusFilter"
        (ngModelChange)="applyTableFilters()"
      >
        <nz-option nzValue="all"        [nzLabel]="'ADMIN.ANNOUNCEMENTS.STATUS.ALL' | translate"></nz-option>
        <nz-option nzValue="draft"      [nzLabel]="'ADMIN.ANNOUNCEMENTS.STATUS.draft' | translate"></nz-option>
        <nz-option nzValue="scheduled"  [nzLabel]="'ADMIN.ANNOUNCEMENTS.STATUS.scheduled' | translate"></nz-option>
        <nz-option nzValue="published"  [nzLabel]="'ADMIN.ANNOUNCEMENTS.STATUS.published' | translate"></nz-option>
      </nz-select>
    </div>
  </nz-card>

  <nz-table
    #annTable
    [nzData]="displayAnnouncements"
    [nzLoading]="loadingAnnouncements"
    [nzFrontPagination]="true"
    [nzPageSize]="pageSize"
    [nzPageIndex]="pageIndex"
    (nzPageIndexChange)="pageIndex = $event"
    (nzPageSizeChange)="onPageSizeChange($event)"
    [nzShowSizeChanger]="true"
    [nzShowQuickJumper]="true"
  >
    <thead>
    <tr>
      <th nzShowSort [nzSortFn]="sortByTitle">
        {{ 'ADMIN.ANNOUNCEMENTS.TABLE.TITLE' | translate }}
      </th>
      <th nzShowSort [nzSortFn]="sortByProperty">
        {{ 'ADMIN.ANNOUNCEMENTS.TABLE.PROPERTY' | translate }}
      </th>
      <th nzShowSort [nzSortFn]="sortByUrgency">
        {{ 'ADMIN.ANNOUNCEMENTS.TABLE.URGENCY' | translate }}
      </th>
      <th nzShowSort [nzSortFn]="sortByStatus">
        {{ 'ADMIN.ANNOUNCEMENTS.TABLE.STATUS' | translate }}
      </th>
      <th nzShowSort [nzSortFn]="sortByValidity">
        {{ 'ADMIN.ANNOUNCEMENTS.TABLE.VALIDITY' | translate }}
      </th>
      <th nzShowSort [nzSortFn]="sortByScheduled">
        {{ 'ADMIN.ANNOUNCEMENTS.TABLE.SCHEDULED' | translate }}
      </th>
      <th>{{ 'ADMIN.ANNOUNCEMENTS.TABLE.ACTIONS' | translate }}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let announcement of annTable.data">
      <td>
        <div class="table-title">{{ announcement.title }}</div>
        <div class="table-sub">{{ announcement.summary }}</div>
      </td>
      <td>
        <div class="table-property">
          <!-- Multiple properties: show count + first address + "...more" -->
          <ng-container *ngIf="announcement.propertyCount > 1; else singleProperty">
            <div class="table-property-main">
              {{ 'ADMIN.ANNOUNCEMENTS.TABLE.PROPERTY_MULTI' | translate:{ count: announcement.propertyCount } }}
            </div>
            <div class="table-property-sub" *ngIf="announcement.propertyAddresses?.length">
              {{ announcement.propertyAddresses[0] }}
              <ng-container *ngIf="announcement.propertyAddresses.length > 1">
                &nbsp;(
                {{ 'ADMIN.ANNOUNCEMENTS.TABLE.PROPERTY_MULTI_MORE' | translate:{
                extra: announcement.propertyAddresses.length - 1
              } }}
                )
              </ng-container>
            </div>
          </ng-container>

          <!-- Single property: behave as before -->
          <ng-template #singleProperty>
            <div class="table-property-main">
              {{ announcement.propertyAddress || '-' }}
            </div>
          </ng-template>
        </div>
      </td>
      <td>
        <nz-tag [nzColor]="announcement.urgency === 'urgent' ? 'red' : 'blue'">
          {{ announcement.urgency === 'urgent' ? ('ADMIN.ANNOUNCEMENTS.URGENCY.URGENT' | translate) : ('ADMIN.ANNOUNCEMENTS.URGENCY.NORMAL' | translate) }}
        </nz-tag>
      </td>
      <td>
        <nz-tag [nzColor]="announcement.status === 'published' ? 'green' : announcement.status === 'scheduled' ? 'gold' : 'default'">
          {{ ('ADMIN.ANNOUNCEMENTS.STATUS.' + (announcement.status || 'draft')) | translate }}
        </nz-tag>
      </td>
      <td>
        <div>{{ announcement.validFrom ? (announcement.validFrom | date:'short') : '-' }}</div>
        <div>{{ announcement.validTo ? (announcement.validTo | date:'short') : '-' }}</div>
      </td>
      <td>
        {{ announcement.scheduledFor ? (announcement.scheduledFor | date:'short') : (announcement.sentAt ? (announcement.sentAt | date:'short') : '-') }}
      </td>
      <td>
        <div class="table-actions">
          <!-- Edit -->
          <span
            nz-tooltip
            [nzTooltipTitle]="'ADMIN.ANNOUNCEMENTS.TABLE.EDIT' | translate"
            nzTooltipPlacement="top"
          >
          <button
            *ngIf="canWriteAnnouncements"
            nz-button
            nzType="text"
            nzShape="circle"
            (click)="editAnnouncement(announcement)"
            [disabled]="deleting || saving || scheduling"
            [attr.aria-label]="'ADMIN.ANNOUNCEMENTS.TABLE.EDIT' | translate"
          >
          <span nz-icon nzType="edit"></span>
            </button>
          </span>

          <!-- History -->
          <span
            nz-tooltip
            [nzTooltipTitle]="'ADMIN.ANNOUNCEMENTS.TABLE.HISTORY' | translate"
            nzTooltipPlacement="top"
          >
            <button
              nz-button
              nzType="text"
              nzShape="circle"
              (click)="showHistory(announcement)"
              [disabled]="deleting"
              [attr.aria-label]="'ADMIN.ANNOUNCEMENTS.TABLE.HISTORY' | translate"
            >
            <span nz-icon nzType="history"></span>
            </button>
          </span>

          <!-- Delete -->
          <span
            *ngIf="canDeleteAnnouncements"
            nz-tooltip
            [nzTooltipTitle]="'ADMIN.ANNOUNCEMENTS.TABLE.DELETE' | translate"
            nzTooltipPlacement="top"
          >
            <button
              nz-button
              nzType="text"
              nzShape="circle"
              nzDanger
              (click)="confirmDelete(announcement)"
              [disabled]="deleting || saving || scheduling"
              [nzLoading]="deleting"
              [attr.aria-label]="'ADMIN.ANNOUNCEMENTS.TABLE.DELETE' | translate"
            >
              <span nz-icon nzType="delete"></span>
            </button>
          </span>
        </div>
      </td>
    </tr>
    </tbody>
  </nz-table>
</div>
